import React from 'react';
import LOOKUP from 'constants/lookup';

import VisibilityIcon from '@mui/icons-material/Visibility';
// Basic Components
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import MultiSelectInput from 'screens/components/basic/MultiSelectInput';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "SalesSummaryDetails";

const Header = ({ orderType, categoryOptions, groupByOptions, orderTypesOptions, onlineOrderTypesOptions, detailsToIncludeOptions, isCannabis, showBody, download, isCannabisOptions, ...props}) => {
    return(
        <CardSimple className="p-1">
            <div className="row row_margin_none">
                <div className="row">
                    <div className="col-xs-6 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                        <DatePickerInput
                            name={componentName + LOOKUP.report.common.beginDate.name}
                            floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                            hintText={LOOKUP.report.common.beginDate.label + "*"}
                            fullWidth={true}
                            required
                        />
                    </div> {/* .col */}
                    <div className="col-xs-6 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                        <DatePickerInput
                            name={componentName + LOOKUP.report.common.endDate.name}
                            floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                            hintText={LOOKUP.report.common.endDate.label + "*"}
                            fullWidth={true}
                        />
                    </div> {/* .col */}
                    <div className="col-xs-12 col-sm-6 col-md-3 col-lg-4 col-xl-4">
                        <BranchSelectAutoCompleteInput
                            name={componentName + LOOKUP.report.common.branchName}
                            label={LOOKUP.report.common.branch + "*"}
                        />
                    </div> {/* .col */}
                    <div className="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-2">
                        <SelectInput
                            name={componentName + "IsCannabis"}
                            fullWidth={true}
                            defaultValue="2"
                            label={"Type"}
                            floatingLabelText={"Type"}
                            hintText={"Type"}
                            options={isCannabisOptions && isCannabisOptions.length > 0 ? isCannabisOptions : []}
                        />
                    </div> {/* .col */}
                    <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                        <SelectInput
                            name={componentName + "Category"}
                            fullWidth={true}
                            label={"Category"}
                            floatingLabelText={"Category"}
                            hintText={"Category"}
                            defaultValue={"0"}
                            options={categoryOptions && categoryOptions.length > 0 ? (isCannabis == 0 ? categoryOptions.filter(x => !x.isCannabis) : (isCannabis == 1 ? categoryOptions.filter(x => x.isCannabis) : categoryOptions)) : []}
                        />
                    </div> {/* .col */}
                    <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-3">
                        <SelectInput
                            name={componentName + "GroupBy"}
                            fullWidth={true}
                            defaultValue={"Day"}
                            label={"Report By"}
                            floatingLabelText={"Report By"}
                            hintText={"Report By"}
                            options={groupByOptions && groupByOptions.length > 0 ? groupByOptions : []}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-3">
                        <SelectInput
                            name={componentName + "OrderType"}
                            fullWidth={true}
                            defaultValue={"0"}
                            label={"Sale Type"}
                            floatingLabelText={"Sale Type"}
                            hintText={"Sale Type"}
                            options={orderTypesOptions && orderTypesOptions.length > 0 ? orderTypesOptions : []}
                        />
                    </div>
                    {
                        orderType == 2 &&
                        <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-3">
                            <SelectInput
                                name={componentName + "OnlineOrderType"}
                                fullWidth={true}
                                defaultValue={"5"}
                                label={"Online Sale Type"}
                                floatingLabelText={"Online Sale Type"}
                                hintText={"Online Sale Type"}
                                options={onlineOrderTypesOptions && onlineOrderTypesOptions.length > 0 ? onlineOrderTypesOptions : []}
                            />
                        </div>
                    }
                    <div className="col-xs-12 col-sm-6 col-md-3 col-lg-4 col-xl-4">
                        <MultiSelectInput
                            defaultValues={detailsToIncludeOptions.map(item => item.value)}
                            name={`${componentName}DetailsToInclude`}
                            label="Details to Include"
                            floatingLabelText="Details to Include"
                            hintText="Details to Include"
                            options={detailsToIncludeOptions}
                            fieldName={'Details'}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1 mb_xs p-0 pt-2 pb-2">
                        <Button
                            type="IconInButton"
                            className="pull-right mt-2 ml-1 btnNewBrandPOS"
                            name={componentName + LOOKUP.report.common.viewReport.name}
                            label={LOOKUP.report.common.viewReport.label}
                            icon={<VisibilityIcon />}
                            onTouchTap={showBody}
                        />
                        <Button
                            type="DownloadButton"
                            className="pull-right mt-2 btnNewBrandPOS"
                            name={componentName + LOOKUP.report.common.downloadReport.name}
                            label={LOOKUP.report.common.downloadReport.label}
                            onTouchTap={download}
                        />
                    </div>
                </div>
                <br />
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <p className="purpleText"><b>Note: </b><strong className="blue-text"><i>Only completed & partially refunded orders will be counted in this report, the profit may change based on the change in the cost of the products.</i></strong></p>
                    <p><b><i>The Total Gross Profit is calculated using Exact Cost.</i></b></p>
                    <p><b><i>All values, except for tax related columns, do not include tax.</i></b></p>
                </div>
            </div>
        </CardSimple>
    )
};

export default Header;
